import builder from '../builder';
import Dislike2 from '../../streamline-icons/bold/dislike-2.svg';

export default builder('IconDislike2Bold', Dislike2);
